<div>
  @if (isExternal && UploadMessageExternal) {
    <p-message severity="warn" icon="pi pi-exclamation-triangle" data-test-id="upload-external-messages">
      <p class="font-semibold">{{ UploadMessageExternal.summary }}</p>
      <p>{{ UploadMessageExternal.detail }}</p>
    </p-message>
  }
  @if (UploadLengthExcessMessage) {
    <p-message severity="warn" icon="pi pi-exclamation-triangle" [closable]="true">
      <p class="font-semibold">{{ UploadLengthExcessMessage.summary }}</p>
      <p>{{ UploadLengthExcessMessage.detail }}</p>
    </p-message>
  }
</div>
@if (!isLimitFour) {
  <form [formGroup]="descriptionForm">
    <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget">
      <div class="col-span-12 md:col-span-6 lg:col-span-5 pl-2 pr-2">
        <div class="field" [class.p-disabled]="disableComponent">
          <label class="field-required" data-test-id="document-types-label">Document Types:</label>
          <div class="p-field-value">
            <p-multiSelect
              [placeholder]="docTypesPlaceholder"
              [filter]="false"
              [options]="documentTypesList"
              [disabled]="disableComponent || isSuggestedChangesProcess || nomncRescindSelected"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="selectedDocumentTypes"
              (onChange)="showUploadButton(selectedDocumentTypes)"
              appendTo="body"
              data-test-id="document-types-multiselect"
              display="chip"
            ></p-multiSelect>
          </div>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6 lg:col-span-5 pr-6">
        <div class="field" [class.p-disabled]="disableComponent">
          <label [class.field-required]="isDocumentTypesOther" data-test-id="description-label">
            Description:
          </label>
          <div class="p-field-value">
            <input
              placeholder="25 Characters Limit"
              pInputText
              type="text"
              trimInputValue
              formControlName="fileDescription"
              (input)="showUploadButton(selectedDocumentTypes)"
              data-test-id="file-description-input"/>
              <errors-messages
                [control]="descriptionForm.get('fileDescription')"
              ></errors-messages>
            </div>
          </div>
        </div>
        <div class="col-span-12 md:col-span-12 lg:col-span-2 pl-2 pr-0">
          <div class="field pr-2">
            @if (showButton && !disableComponent && descriptionForm.valid && !isLimitFour) {
              <document-select-upload
                [multiple]="false"
                [maxFileSize]="maxFileSize"
                [accept]="allowedExtensions.join()"
                [shouldShowCSPopup]="shouldShowCSPopup"
                [authType]="authorizationSearch?.facilityType"
                [isPacCommercial]="isPacCommercial"
                [serviceLinesSummary]="serviceLinesSummary"
                [authDocuments]="authDocuments"
                [programState]="programState"
                [crsMessage]="crsMessage"
                (selectFiles)="addFile($event)"
                (errorValidation)="onError($event)"
                (createContinuedStay)="createContinuedStay.emit()"
                (levelAdjustment)="onSelectlevelAdjustment()"
              ></document-select-upload>
            }
          </div>
        </div>
      </div>
    </form>
  }
  @if (isLimitFour) {
    <div class="mb-4 warn-message p-text-bold" data-test-id="limit-four-message">You have reached your limit of 4 files.</div>
  }

  @if (uploadedFiles?.length) {
    <div>
      <selected-document
        [uploadedFiles]="uploadedFiles"
        (deleteItem)="deleteItem($event)"
      ></selected-document>
    </div>
  }
  @if (showSaveButton) {
    <div class="pt-4 flex justify-end">
      <button
        pButton
        type="button"
        label="Save"
        class="p-button-action"
        [disabled]="isUploading"
        (click)="uploadDocuments();"
        data-test-id="upload-documents-button"
      ></button>
    </div>
  }

  <p-dialog
    header="{{ warningPopupHeader }}"
    appendTo="body"
    [style]="{ width: '500px' }"
    [modal]="true"
    [(visible)]="display"
    (visibleChange)="onBack()"
    >
    @if (fileNameInvalidErrors) {
      The file name contains invalid characters. Please rename the file and try again.
    }
    @if (!fileNameInvalidErrors && fileTypeErrors) {
      Please upload only {{ allowedExtensions.join(', ') }}
    }
    @if (!fileNameInvalidErrors && !fileTypeErrors && fileSizeErrors) {
      Maximum upload size is {{ maxFileSize / (1024 * 1024) }}Mb
    }

    <p-footer>
      <button
        pButton
        type="button"
        class="p-button-secondary"
        label="Back"
        (click)="onBack()"
      ></button>
    </p-footer>
  </p-dialog>
